import { Controller } from '@hotwired/stimulus'
import { Modal } from 'bootstrap'
import escapeHtml from '../../utils/sanitize'
import fetchWithHandlingLoginRedirect from '../../modules/utils/fetchWithHandlingLoginRedirect'
import { trans, PLEASE_TRY_AGAIN } from '../../translator'

export default class extends Controller {
  confirmAcceptInviteModal

  static values = { accountLinkCount: Number }
  static targets = ['content', 'accountId', 'acceptInviteModal', 'unlinkAccountModal', 'cancelInvitationModal', 'accountLinksTable', 'errors', 'errorTemplate']
  selectedAccountLink = null

  sendInvite () {
    this.errorsTarget.innerHTML = ''

    if (this.accountIdTarget.value) {
      fetchWithHandlingLoginRedirect(
        '/internal/api/account-link/invite',
        {
          method: 'POST',
          body: JSON.stringify({
            redactedAccountId: escapeHtml(this.accountIdTarget.value)
          })
        })
        .then(response => {
          if (!response.ok) {
            return Promise.reject(response)
          }
          return response.json()
        })
        .then(accountLink => {
          this.accountLinkCountValue += 1
          this.contentTarget.classList.remove('d-none')
          this.accountLinksTableTarget.insertAdjacentHTML('beforeend', accountLink)
        })
        .catch(async response => {
          await this.showError(response)
        })
    }
  }

  acceptInvite (event) {
    this.errorsTarget.innerHTML = ''
    this.selectedAccountLink = event.currentTarget.closest('tr')

    const modal = new Modal(this.acceptInviteModalTarget)
    modal.show()
  }

  confirmAcceptInvite () {
    fetchWithHandlingLoginRedirect('/internal/api/account-link/invite/' + this.selectedAccountLink.dataset.accountLinkId + '/accept', { method: 'POST' })
      .then(response => {
        if (!response.ok) {
          return Promise.reject(response)
        }
        return response.json()
      })
      .then(accountLink => {
        this.selectedAccountLink.outerHTML = accountLink
      })
      .catch(async response => {
        await this.showError(response)
      })
  }

  unlinkAccount (event) {
    this.errorsTarget.innerHTML = ''
    this.selectedAccountLink = event.currentTarget.closest('tr')

    const modal = new Modal(this.unlinkAccountModalTarget)
    modal.show()
  }

  cancelInvitation (event) {
    this.errorsTarget.innerHTML = ''
    this.selectedAccountLink = event.currentTarget.closest('tr')

    const modal = new Modal(this.cancelInvitationModalTarget)
    modal.show()
  }

  confirmUnlinkAccount () {
    fetchWithHandlingLoginRedirect('/internal/api/account-link/' + this.selectedAccountLink.dataset.accountLinkId + '/unlink', { method: 'DELETE' })
      .then(response => {
        if (!response.ok) {
          return Promise.reject(response)
        }
        this.accountLinkCountValue -= 1
        if (this.accountLinkCountValue === 0) {
          this.contentTarget.classList.add('d-none')
        }

        this.selectedAccountLink.remove()
      })
      .catch(async response => {
        await this.showError(response)
      })
  }

  async showError (response) {
    const error = this.errorTemplateTarget.cloneNode(true)

    switch (response.status) {
      case 400:
      case 403:
        error.querySelector('.alert-text').innerHTML = await response.json()
        break
      default:
        error.querySelector('.alert-text').innerHTML = trans(PLEASE_TRY_AGAIN, {}, 'accounts')
    }

    error.classList.remove('d-none')
    this.errorsTarget.insertAdjacentElement('beforeend', error)
  }

  removeError (event) {
    event.currentTarget.parentNode.remove()
  }
}
